import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#22A06B",
      d: "M10 18.334a8.333 8.333 0 1 1 0-16.667 8.333 8.333 0 0 1 0 16.667m-.83-5L15.06 7.44l-1.178-1.178-4.714 4.714-2.357-2.358-1.178 1.179z"
    }, null, -1)
  ]))]))
}
export default { render: render }